import { ref as fbref, listAll, deleteObject, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { storage } from '../firebase/firebaseConfig';

export const LOGOTIPO_ACCEPT = 'image/png,image/jpeg,image/jpg,image/svg+xml';
const LOGOTIPO_MAX_MB = 2;

/** Devuelve null si el archivo es válido; 'tipo' o 'tamano' si no lo es. */
export const validarLogotipo = (file: File | undefined | null): 'tipo' | 'tamano' | null => {
    if (!file) return null;
    if (!['image/png', 'image/jpeg', 'image/jpg', 'image/svg+xml'].includes(file.type)) return 'tipo';
    if (file.size / 1024 / 1024 > LOGOTIPO_MAX_MB) return 'tamano';
    return null;
};

/** Elimina logotipos existentes en un directorio de Firebase Storage. */
export const eliminarLogotipo = async (directorio: string): Promise<void> => {
    const listRef = fbref(storage, directorio);
    const res = await listAll(listRef);
    for (const item of res.items) {
        if (item.name.startsWith('logotipo')) {
            await deleteObject(item);
        }
    }
};

/** Sube el logotipo a Firebase Storage y regresa su URL de descarga. */
export const subirLogotipo = (file: File, ruta: string): Promise<string> => {
    const ext = file.name.split('.').pop() || 'png';
    const storageRef = fbref(storage, `${ruta}/logotipo.${ext}`);
    const uploadTask = uploadBytesResumable(storageRef, file);
    return new Promise((resolve, reject) => {
        uploadTask.on('state_changed',
            () => { /* progreso no requerido */ },
            (error) => reject(error),
            async () => resolve(await getDownloadURL(uploadTask.snapshot.ref))
        );
    });
};
